import { connect } from 'react-redux';
import { pushModal } from '../../Modals/redux/basicActions';
import { ModalType } from '../../Modals/redux/types';
const mapStateToProps = (state, props)=>({});
const mapDispatchToProps = (dispatch)=>({
        pushAwardsModal: (params)=>{
            dispatch(pushModal(ModalType.RECEIVED_AWARDS, {
                wrapInModal: false,
                params
            }));
        }
    });
export default connect(mapStateToProps, mapDispatchToProps);
